import classNames from "classnames";
import * as React from "react";
import { ThemeColorType } from "~/types/theme-color";
import { generateColumnImageProps } from "~/utils/image-utils";
import ContentSection from "../content-section/content-section";
import TitleLinkTop from "../title-link-top/title-link-top";
import ImageTextListItem, { ImageTextListItemProps } from "./image-text-list-item/image-text-list-item";

export interface ImageTextListProps {
    title?: string;
    viewMoreLink?: string;
    items?: ImageTextListItemProps[];
    maxColumns?: number;
    isFullWidth?: boolean;
    textColor?: ThemeColorType;
    bgColor?: ThemeColorType;
    anchorId?: string;
    hasNoMarginTop?: boolean;
    hasNoMarginBottom?: boolean;
}

const ImageTextList: React.FC<ImageTextListProps> = ({
    title,
    viewMoreLink,
    items,
    maxColumns = 4,
    isFullWidth = true,
    textColor,
    bgColor,
    ...props
}) => {
    const baseClass = "image-text-list";
    const someItemHasImage = items?.some(item => !!item.imageSrc);
    const componentClasses = classNames(baseClass, {
        [`${baseClass}--full-width`]: isFullWidth,
        [`${baseClass}--contains-image`]: someItemHasImage
    });
    const listClasses = classNames(
        `${baseClass}__items`,
        `config-columns config-columns--columns-${maxColumns}`
    );
    const columnImageProps = generateColumnImageProps(maxColumns, isFullWidth);

    return (
        <ContentSection {...props} className={componentClasses}>
            <TitleLinkTop title={title} viewMoreLink={viewMoreLink} />
            <div className={listClasses}>
                {items?.map((item, index) => {
                    return (
                        <ImageTextListItem
                            key={index}
                            {...item}
                            {...columnImageProps}
                            textColor={item.textColor || textColor}
                            bgColor={item.bgColor || bgColor}
                        />
                    );
                })}
            </div>
        </ContentSection>
    );
};

export default ImageTextList;
